import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {validateFields, validateField} from '../../../../utilities/validation/validator';
import lodash from 'lodash';
import ProviderManager from '../../../../provider/providerManager';
import {regexPatterns} from '../../../../utilities/validation/validationVariables';


export const uploadFileForValidation = createAsyncThunk('bankPayment/uploadFileForValidation', async (data) => {
  try {
    const result = await ProviderManager.getProviderData('uploadFileForValidation', [data.extension, data.converted, data.token, data.consumerId]); 
    return {fileName: result.Body.fileName, error: false};

  } catch (error) {
      return {error: true}
  }
});
const initialState = {
  error: false,
  form: {
    file: '',
    fileSize: '',
    validatedFileName: '',
    valid: '',  
    errors: {},
    rules: {
      file: {
        required: {value: true, error: 'ערך לא תקין'},
        pattern: {
          value: regexPatterns.bankFileRegex,
          error: 'ערך לא תקין',
        },
      },
      fileSize: {
        maxFileSize: {
          value: 10240,
          error: 'ערך לא תקין',
        },
      },       
     },
  },
};

const BankPaymentSlice = createSlice({
  name: 'bankPayment',
  initialState: initialState,
  reducers: {
    resetState: state => initialState,
    validateHandler: {
      reducer(state, action) {                                  
           state.form = action.payload
      },
      prepare(payload) {
          const validate = validateFields(lodash.cloneDeep(payload));             
          return { payload: validate } ;
      }          
  },
    changeHandler: {
      
      reducer(state, action) {
        state.form = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const fileSize = payload.target.size;
        const form = lodash.cloneDeep(payload.form);
        validateField(form, name, value);
        validateField(form, 'fileSize', fileSize);
        const validateAll = validateFields(lodash.cloneDeep(form));
        return {payload: validateAll};
      },
    },
    removeFile: {
      reducer(state, action) {
        return {...state, form: {...state.form, file:'', fileSize: '', guid: '', validatedFileName: '' } }
      },
    },
  },
  extraReducers: {
    [uploadFileForValidation.pending]: (state, action) => {
       return {...state, error : false}
    }, 
    [uploadFileForValidation.fulfilled]: (state, action) => {
      if(action.payload.error || action.payload.fileName.trim() == "") return {...state, error : true}
      return {...state, form : {...state.form , validatedFileName: action.payload.fileName}}
    }, 
  }
});

export const {changeHandler, validateHandler, removeFile, resetState} = BankPaymentSlice.actions;

export default BankPaymentSlice.reducer;
